import { AddIcon } from '@chakra-ui/icons';
import { HStack } from '@chakra-ui/react';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useGetVoicePolicies from './queries/useGetVoicePolicies';

import { Button, Text } from '@/components/v4';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import useColumnState from '../../../hooks/useColumnState';

import { getVoicePoliciesTableColumns } from './voicePoliciesTableConfig';

export default function VoicePolicies() {
    const gridRef = useRef();
    const navigate = useNavigate();

    const [tableData, setTableData] = useState({
        columns: [],
        data: [],
    });

    const handleEditVoicePolicy = useCallback(
        (voicePolicyData) => {
            navigate(`/voice-policies/edit/${voicePolicyData.id}`);
        },
        [navigate],
    );

    const handleAddVoicePolicy = () => {
        navigate('/voice-policies/add');
    };

    const baseColumns = useMemo(
        () =>
            getVoicePoliciesTableColumns({
                onEditVoicePolicy: handleEditVoicePolicy,
            }),
        [handleEditVoicePolicy],
    );

    const { columns, onColumnVisible } = useColumnState(baseColumns);

    const tableDataWithColumns = useMemo(
        () => ({
            columns,
            data: tableData.data,
        }),
        [columns, tableData.data],
    );

    const { refetch, isRefetching, isFetching } = useGetVoicePolicies(
        setTableData,
        gridRef,
        baseColumns,
    );

    const isFetchingData = isRefetching || isFetching;

    const titleName = 'Voice Policies';

    return (
        <>
            <HStack justifyContent="space-between" marginBottom={5}>
                <Text sx={{ fontSize: '20', fontWeight: '500' }}>
                    Voice Policies
                </Text>
            </HStack>

            <AGGridMain
                gridRef={gridRef}
                tableData={tableDataWithColumns}
                isLoading={isFetchingData}
                titleName={titleName}
                refetch={refetch}
                onColumnVisible={onColumnVisible}
                extraComponents={
                    <HStack pl={5} spacing={2}>
                        <Button
                            leftIcon={<AddIcon />}
                            onClick={handleAddVoicePolicy}
                            size="sm"
                            padding="6px 12px">
                            Add Voice Policy
                        </Button>
                    </HStack>
                }
            />
        </>
    );
}
